import {
  BoxProps,
  chakra,
  forwardRef,
  Tooltip as ChakraTooltip,
  TooltipProps as ChakraTooltipProps,
} from '@chakra-ui/react';

export interface TooltipProps extends Omit<ChakraTooltipProps, 'shouldWrapChildren'> {
  shouldWrapChildren?: boolean | 'block';
  wrapperProps?: BoxProps;
}
/**
 * A tooltip is a brief, informative message that appears when a user interacts with an element. Tooltips are usually initiated in one of two ways: through a mouse-hover gesture or through a keyboard-hover gesture.
 */
const Tooltip = forwardRef<TooltipProps, 'div'>((props, ref) => {
  const { children, shouldWrapChildren, wrapperProps = {}, ...rest } = props;
  const properties: ChakraTooltipProps = {
    bg: 'neutral.10',
    children,
    hasArrow: true,
    maxWidth: 320,
    placement: 'top',
    ...rest,
  };
  if (shouldWrapChildren) {
    properties.children = (
      <chakra.span display={shouldWrapChildren === 'block' ? 'block' : 'inline-block'} sx={wrapperProps} tabIndex={0}>
        {children}
      </chakra.span>
    );
  }
  return <ChakraTooltip {...properties} ref={ref} />;
});

export default Tooltip;
